import { Link, type LinkProps } from 'react-router-dom';
import {
  linkButtonClass,
  type LinkButtonSize,
  type LinkButtonVariant,
} from '@platform/ui';

interface RouterLinkButtonProps extends Omit<LinkProps, 'className'> {
  variant?: LinkButtonVariant;
  size?: LinkButtonSize;
  className?: string;
}

/**
 * LinkButton 의 시각 언어 + react-router SPA 이동.
 *
 * ui 패키지의 LinkButton 은 순수 <a href> 라 내부 라우트에 쓰면 전체 새로고침이
 * 난다. 내부 이동 CTA 는 이 컴포넌트를 쓴다. 스킨은 linkButtonClass 한 곳에서만
 * 오므로 LinkButton 과 항상 동일하게 유지된다(스타일 drift 없음).
 *
 * 외부 링크(target="_blank")나 anchor 시맨틱이 필요하면 그냥 LinkButton 을 쓴다.
 */
export function RouterLinkButton({
  variant = 'dark',
  size = 'md',
  className = '',
  children,
  ...rest
}: RouterLinkButtonProps) {
  return (
    <Link className={linkButtonClass({ variant, size, className })} {...rest}>
      {children}
    </Link>
  );
}
